import React, { useEffect } from 'react'
import Img from 'gatsby-image'
import { useStaticQuery } from 'gatsby'
import styled from '@emotion/styled'
import Marquee from 'react-fast-marquee'

import { breakpoints } from '../../utils/styles'

const Logos = props => {
  const data = useStaticQuery(
    graphql`
      query {
        amazon: file(relativePath: { eq: "logos/amazon.png" }) {
          childImageSharp {
            fluid(maxWidth: 410) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        nature: file(relativePath: { eq: "logos/nature.png" }) {
          childImageSharp {
            fluid(maxWidth: 410) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        stylist: file(relativePath: { eq: "logos/stylist.png" }) {
          childImageSharp {
            fluid(maxWidth: 410) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        courier: file(relativePath: { eq: "logos/courier.png" }) {
          childImageSharp {
            fluid(maxWidth: 410) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        lsn: file(relativePath: { eq: "logos/lsn.png" }) {
          childImageSharp {
            fluid(maxWidth: 410) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        alpha: file(relativePath: { eq: "logos/alpha.png" }) {
          childImageSharp {
            fluid(maxWidth: 410) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        planet: file(relativePath: { eq: "logos/planet.png" }) {
          childImageSharp {
            fluid(maxWidth: 410) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        revital: file(relativePath: { eq: "logos/revital.png" }) {
          childImageSharp {
            fluid(maxWidth: 410) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        daylesford: file(relativePath: { eq: "logos/daylesford.png" }) {
          childImageSharp {
            fluid(maxWidth: 410) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        vegankind: file(relativePath: { eq: "logos/vegankind.png" }) {
          childImageSharp {
            fluid(maxWidth: 410) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        rebel: file(relativePath: { eq: "logos/1rebel.png" }) {
          childImageSharp {
            fluid(maxWidth: 410) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `
  )

  useEffect(() => {}, [])

  return (
    <>
      <Wrapper {...props}>
        <div className="wrap">
          <Img
            fluid={data.amazon.childImageSharp.fluid}
            style={{ width: 80, top: 5 }}
            alt="Amazon"
          />
        </div>
        <div className="wrap">
          <Img
            fluid={data.nature.childImageSharp.fluid}
            style={{ width: 90, height: 23 }}
            alt="As Nature Intended"
          />
        </div>
        <div className="wrap">
          <Img
            fluid={data.stylist.childImageSharp.fluid}
            style={{ width: 80 }}
            alt="Stylist Magazine"
          />
        </div>
        <div className="wrap">
          <Img
            fluid={data.courier.childImageSharp.fluid}
            style={{ width: 60 }}
            alt="Courier"
          />
        </div>
        <div className="wrap">
          <Img
            fluid={data.lsn.childImageSharp.fluid}
            style={{ width: 60, top: 5 }}
            alt="LSN Global"
          />
        </div>
        <div className="wrap">
          <Img
            fluid={data.alpha.childImageSharp.fluid}
            style={{ width: 150 }}
            alt="Alphagreen"
          />
        </div>
        <div className="wrap">
          <Img
            fluid={data.planet.childImageSharp.fluid}
            style={{ width: 40 }}
            alt="Planet Organic"
          />
        </div>
        <div className="wrap">
          <Img
            fluid={data.revital.childImageSharp.fluid}
            style={{ width: 70, top: 2 }}
            alt="Revital"
          />
        </div>
        <div className="wrap">
          <Img
            fluid={data.daylesford.childImageSharp.fluid}
            style={{ width: 100 }}
            alt="Daylesford Organic Farm Gloucestershire"
          />
        </div>
        <div className="wrap">
          <Img
            fluid={data.vegankind.childImageSharp.fluid}
            style={{ width: 90, top: 2 }}
            alt="The Vegan Kind Supermarket"
          />
        </div>
        <div className="wrap">
          <Img
            fluid={data.rebel.childImageSharp.fluid}
            style={{ width: 70 }}
            alt="1Rebel"
          />
        </div>
      </Wrapper>
    </>
  )
}

export default Logos

export const Wrapper = styled.div`
  padding: 20px 0;
  background: white;
  flex-wrap: wrap;
  color: #211f15;
  align-items: center;
  justify-content: center;
  display: flex;
  text-align: center;

  .wrap {
    margin: 10px;
  }

  img {
    filter: grayscale(100%);
  }

  @media (max-width: ${breakpoints.s}px) {
    padding: 40px 0;
  }
`
